import { http } from '@/http/axios.js'

// 列表
export function getListAPI(params) {
  return http({
    url: `/api/manage/notice/list`,
    method: 'get',
    params
  })
}

export function delAPI(id) {
  return http({
    url: `/api/manage/notice/delete?id=${id}`,
    method: 'post',
    data: {}
  })
}
export function addAPI(data) {
  return http({
    url: `/api/manage/notice/add`,
    method: 'post',
    data
  })
}

export function editAPI(data) {
  return http({
    url: `/api/manage/notice/edit`,
    method: 'post',
    data
  })
}
export function changeStatusAPI(data) {
  return http({
    url: `/manage/notice/changeStatus`,
    method: 'post',
    data
  })
}
export function getDetailAPI(id) {
  return http({
    url: `/api/manage/notice/detail`,
    method: 'get',
    params: { id }
  })
}

